export const urlArgs = args => args || ''
